import { render, staticRenderFns } from "./EditarUsuario.vue?vue&type=template&id=2505a573&scoped=true"
import script from "./EditarUsuario.vue?vue&type=script&lang=js"
export * from "./EditarUsuario.vue?vue&type=script&lang=js"
import style0 from "./EditarUsuario.vue?vue&type=style&index=0&id=2505a573&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505a573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2505a573')) {
      api.createRecord('2505a573', component.options)
    } else {
      api.reload('2505a573', component.options)
    }
    module.hot.accept("./EditarUsuario.vue?vue&type=template&id=2505a573&scoped=true", function () {
      api.rerender('2505a573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditarUsuario.vue"
export default component.exports